import styled from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.layout.spacing.decy};
  `};
`;
